import { __read, __assign } from 'tslib';
import * as React from 'react';
import classNames from 'classnames';
import BaseHeading from '../../common/BaseHeading/BaseHeading.esm.js';
import BaseSectionWithAnalyticsContext from '../../common/BaseSection/BaseSectionWithAnalyticsContext.esm.js';
import { SmallImageContext } from '../../common/ContentfulImage/SmallImageContext.esm.js';
import { Grid } from '../../common/Grid/Grid.esm.js';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import { useMinMediaQuery } from '@invitae/react-hooks';
import { getPixelsBasedOnColumns } from '../../utils/misc.esm.js';
import styles from './StepperHoverSection.module.esm.js';

var DESKTOP_MIN_WIDTH_AVAILABLE = 720;
var StepperHoverSection = function (_a) {
    var _b = _a.fields, body = _b.body, heading = _b.heading, headingAlignment = _b.headingAlignment, image = _b.image, internalName = _b.internalName, items = _b.items, theme = _b.theme, footer = _b.footer, id = _a.id, dataCy = _a["data-cy"];
    var _c = __read(React.useState(items[0].sys.id), 2), isSelected = _c[0], setIsSelected = _c[1];
    var ref = React.useRef(null);
    var _d = __read(React.useState(0), 2), selectedBodySize = _d[0], setSelectedBodySize = _d[1];
    var isDesktop = useMinMediaQuery(DESKTOP_MIN_WIDTH_AVAILABLE);
    var handleSelected = function (id) {
        setIsSelected(id);
    };
    var stepperHoverItems = items.map(function (item) {
        return React.createElement(BaseNucleobaseComponent, __assign({ key: item.sys.id, source: item }, { handleSelected: handleSelected, isSelected: isSelected }));
    });
    var getDynamicSizePanel = React.useCallback(function () {
        var _a;
        if (!(ref === null || ref === void 0 ? void 0 : ref.current) || !((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.children) || !isSelected)
            return;
        var listOfItems = Array.from(ref.current.children);
        var getItemSelected = listOfItems.find(function (child) { return child.getAttribute('id') === isSelected; });
        if (!getItemSelected)
            return;
        var body = ((getItemSelected === null || getItemSelected === void 0 ? void 0 : getItemSelected.children[1]) || {});
        setSelectedBodySize(body === null || body === void 0 ? void 0 : body.offsetHeight);
    }, [isSelected, ref]);
    React.useEffect(function () {
        if (!isDesktop)
            return;
        getDynamicSizePanel();
    }, [getDynamicSizePanel, isDesktop]);
    return (React.createElement(BaseSectionWithAnalyticsContext, { className: classNames(styles.section, styles.root, styles[theme]), "data-cy": dataCy, id: id, sectionName: internalName },
        React.createElement(Grid, { className: styles.grid },
            heading && (React.createElement(BaseHeading, { body: body, bodyClasses: styles.body, className: styles.header, heading: heading, headingAlignment: headingAlignment, headingClasses: styles.heading })),
            React.createElement("div", { className: styles.wrapItems },
                React.createElement("div", { className: classNames(styles.items), ref: ref, role: "list" }, stepperHoverItems),
                isDesktop && React.createElement("div", { "data-testid": "dynamic-space", style: { paddingTop: selectedBodySize } })),
            image && (React.createElement("footer", { className: classNames(styles.footer) },
                React.createElement(SmallImageContext, null,
                    React.createElement(BaseNucleobaseComponent, { classes: { picture: styles.image }, maxImageWidth: getPixelsBasedOnColumns(5), role: "presentation", source: image }))))),
        footer && React.createElement(BaseNucleobaseComponent, { source: footer })));
};

export { StepperHoverSection as default };
//# sourceMappingURL=StepperHoverSection.esm.js.map
